import { useState, useCallback } from 'react';
import { pwt205Api } from '../../../services/pwt205Api';

export function usePWT205Navigation(loadRecord: (id: string) => Promise<void>) {
  const [allIds, setAllIds] = useState<string[]>([]);
  const [currentIdx, setCurrentIdx] = useState(-1);
  const [keyword, setKeyword] = useState('');

  const loadList = useCallback(
    async (kw = keyword) => {
      try {
        const res = await pwt205Api.list(1, 200, kw);
        const ids = res.data.map((r) => r.ft150_01);
        setAllIds(ids);
        setKeyword(kw);
        return ids;
      } catch {
        return [];
      }
    },
    [keyword],
  );

  const navTo = useCallback(
    async (idx: number, ids = allIds) => {
      if (idx < 0 || idx >= ids.length) return;
      setCurrentIdx(idx);
      await loadRecord(ids[idx]);
    },
    [allIds, loadRecord],
  );

  const navFirst = useCallback(() => navTo(0), [navTo]);
  const navLast = useCallback(() => navTo(allIds.length - 1), [allIds, navTo]);
  const navPrev = useCallback(() => navTo(currentIdx - 1), [currentIdx, navTo]);
  const navNext = useCallback(() => navTo(currentIdx + 1), [currentIdx, navTo]);

  const searchAndNav = useCallback(
    async (kw: string) => {
      const ids = await loadList(kw);
      if (ids.length > 0) await navTo(0, ids);
    },
    [loadList, navTo],
  );

  return {
    allIds,
    currentIdx,
    keyword,
    loadList,
    navTo,
    navFirst,
    navLast,
    navPrev,
    navNext,
    searchAndNav,
  };
}
